 
import smartwrap from "smartwrap";

/**
 *
 * @param {HTMLTextAreaElement} textarea
 */
export function createLimitRowsListener(textarea) {
  let lastValue = "";
  return (event) => {
    if (textarea.value.split("\n").length > textarea.getAttribute("rows")) {
      event.preventDefault();
      textarea.value = lastValue;
    }
    lastValue = textarea.value;
  };
}

// Das PDF generiert den Text nicht autmatisch mit Zeilenumbrüchen.
// Deshalb brechen wir es aktuell um, bevor wir es weiter schicken.
// Das ist nur eine Zwsichenlösung! Eigentlich soll der PDF-Generator
// den Text selber umbrechen.
const wrapWidth = 58;

/**
 * @param {string} text
 */
export function wrapAndSliceText(text) {
  const wrapped = smartwrap(text, { width: wrapWidth });
  const sliced = wrapped.split("\n").slice(0, 7).join("\n");
  return sliced;
}
